module.exports = __webpack_public_path__ + "static/media/VerticalLine.bcfbd576.svg";